/**
 * PhotonRemote 11-byte UDP packet header — Rust/C# ile birebir.
 *
 * Layout:
 *   byte 0    : VV(2b) | PacketType(3b) | Flags(3b)
 *   byte 1-3  : session_id u24 BE
 *   byte 4-7  : sequence u32 BE
 *   byte 8    : channel u8
 *   byte 9-10 : payload_length u16 BE
 */
export const HEADER_SIZE = 11;
export var Channel;
(function (Channel) {
    Channel[Channel["Control"] = 0] = "Control";
    Channel[Channel["Video"] = 1] = "Video";
    Channel[Channel["Audio"] = 2] = "Audio";
    Channel[Channel["Input"] = 3] = "Input";
    Channel[Channel["Clipboard"] = 4] = "Clipboard";
    Channel[Channel["Files"] = 5] = "Files";
})(Channel || (Channel = {}));
export var PacketType;
(function (PacketType) {
    PacketType[PacketType["Data"] = 0] = "Data";
    PacketType[PacketType["Ack"] = 1] = "Ack";
    PacketType[PacketType["Nack"] = 2] = "Nack";
    PacketType[PacketType["Ping"] = 3] = "Ping";
    PacketType[PacketType["Pong"] = 4] = "Pong";
    PacketType[PacketType["KeyRotate"] = 5] = "KeyRotate";
    PacketType[PacketType["Control"] = 6] = "Control";
})(PacketType || (PacketType = {}));
export function encodeHeader(h, out, offset = 0) {
    out[offset + 0] =
        ((h.version & 0x3) << 6) |
            ((h.packetType & 0x7) << 3) |
            (h.flags & 0x7);
    out[offset + 1] = (h.sessionId >> 16) & 0xff;
    out[offset + 2] = (h.sessionId >> 8) & 0xff;
    out[offset + 3] = h.sessionId & 0xff;
    out[offset + 4] = (h.sequence >>> 24) & 0xff;
    out[offset + 5] = (h.sequence >>> 16) & 0xff;
    out[offset + 6] = (h.sequence >>> 8) & 0xff;
    out[offset + 7] = h.sequence & 0xff;
    out[offset + 8] = h.channel & 0xff;
    out[offset + 9] = (h.payloadLength >> 8) & 0xff;
    out[offset + 10] = h.payloadLength & 0xff;
}
export function decodeHeader(data) {
    if (data.length < HEADER_SIZE)
        return null;
    const b0 = data[0];
    return {
        version: (b0 >> 6) & 0x3,
        packetType: ((b0 >> 3) & 0x7),
        flags: b0 & 0x7,
        sessionId: (data[1] << 16) | (data[2] << 8) | data[3],
        sequence: ((data[4] << 24) >>> 0)
            | (data[5] << 16)
            | (data[6] << 8)
            | data[7],
        channel: data[8],
        payloadLength: (data[9] << 8) | data[10],
    };
}
export function buildPacket(header, payload) {
    const out = new Uint8Array(HEADER_SIZE + payload.length);
    encodeHeader({ ...header, payloadLength: payload.length }, out, 0);
    out.set(payload, HEADER_SIZE);
    return out;
}
/**
 * DEPRECATED — Faz V: backend /pairing|/unattended|/connect/authorize
 * response'unda `relaySessionId: number` dönüyor; o değeri kullan. Bu naive
 * hash backend SHA-256 ile uyumsuzdu, kullanılırsa relay forward fail olur.
 * Geçici olarak export'u koruyoruz (üçüncü-taraf kullanım yoksa sonra silinir).
 */
export function sessionIdToUint24(sessionId) {
    let h = 0;
    for (let i = 0; i < sessionId.length; i++) {
        h = (h * 31 + sessionId.charCodeAt(i)) & 0xffffff;
    }
    return h >>> 0;
}
